import { ComponentProps, FC } from "react";
import { useSelector } from "react-redux";
import moment from "moment";

import { CalendarOutlined, CheckOutlined, Row, Space, Typography, UserOutlined } from "@ctra/components";
import { Epoch, Nullable, TS } from "@ctra/utils";

import { Enterprise as App, EnterpriseAppState, TodoItemEntity, TodoItemStatus, User } from "@ctra/api";

const { Text } = Typography;

type TaskEntryExtrasProps = {
  task: TodoItemEntity;
  withUser?: boolean;
};

/**
 * Task extras
 * @todo find a better name
 * @todo move to @ctra/components
 * @param endEpoch
 * @param assignedTo
 * @param task
 * @param withUser
 * @constructor
 */
export const TaskEntryExtras: FC<TaskEntryExtrasProps> = ({
  task: { dueDateTs, assignedTo, modifiedEpoch = 0, status, ...task },
  withUser
}) => {
  let dueDateTextType: ComponentProps<typeof Text>["type"];

  const lastModifiedMoment = Epoch.asMoment(modifiedEpoch);
  const dueMoment = dueDateTs ? TS.asMoment(dueDateTs) : null;
  const expired = dueMoment && dueMoment.isBefore(moment());

  /**
   * Gets a green if the task is completed before the due moment
   */
  const isGreen = status === TodoItemStatus.Completed && lastModifiedMoment.isBefore(dueMoment);

  /**
   * Get the user's display name
   */
  const displayName = useSelector<EnterpriseAppState, Nullable<string>>((state) => {
    let result = null;

    if (assignedTo) {
      const user = App.entities.getUserList(state)[assignedTo];

      if (user) {
        result = User.utils.getDisplayName(user);
      } else {
        console.warn(assignedTo, "is not found among", App.entities.getUserList(state));
      }
    }

    return result;
  });

  if (isGreen) {
    dueDateTextType = "success";
  } else if (expired) {
    dueDateTextType = "danger";
  }

  return (
    <Row style={{ gap: "18px" }} align="middle" justify="space-between">
      {assignedTo && displayName && (
        <Text>
          <UserOutlined /> {displayName}
        </Text>
      )}
      {dueMoment && (
        <Text type={dueDateTextType}>
          <Space size="small">
            {isGreen ? <CheckOutlined /> : <CalendarOutlined />}
            {dueMoment.format("MMM D, YYYY")}
          </Space>
        </Text>
      )}
    </Row>
  );
};
